import React from 'react';
import { bool } from 'prop-types';
import { StyledMenu } from './Menu.styled';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import About from '../../About';
import Contact from '../../Contact';
import Home from '../../Home';
import Skills from '../../Skills';
import Project from '../../Project';

const Menu = ({ open, ...props }) => {
  
  const isHidden = open ? true : false;
  const tabIndex = isHidden ? 0 : -1;

  return (
    <Router basename={process.env.PUBLIC_URL}>
    <StyledMenu open={open} aria-hidden={!isHidden} {...props}>
    <a href="/" tabIndex={tabIndex}>
        <span aria-hidden="true">🏠</span>
        Home
      </a>
      <a href="/about" tabIndex={tabIndex}>
        <span aria-hidden="true">💁🏻‍♂️</span>
        About Me
      </a>
      <a href="/skills/" tabIndex={tabIndex}>
        <span aria-hidden="true">&#x270F;</span>
        Skills
        </a>
      <a href="/project/" tabIndex={tabIndex}>
        <span aria-hidden="true">&#x1f4f1;</span>
        Projects
        </a>
       <a href="/tutorials/" tabIndex={tabIndex}>
        <span aria-hidden="true">📖</span>
        Tutorials
        </a>

      <a href="/contact/" tabIndex={tabIndex}>
        <span aria-hidden="true">📩</span>
        Contact Me
        </a>
    </StyledMenu>
      <Switch>
        <Route exact path='/' component={Home} />
        <Route path='/contact' component={Contact}/>
        <Route path='/about' component={About} />
        <Route path='/skills' component={Skills} />
        <Route path='/project' component={Project} />
      </Switch>
    </Router>
  )
}

Menu.propTypes = {
  open: bool.isRequired,
}

export default Menu;